import React from 'react';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

const AsyncRecommendPremiumToStandardModalComponent = lazyAfterPaint(
	() =>
		import(/* webpackChunkName:  "async-recommend-premium-to-standard-modal" */ './index.tsx').then(
			({ RecommendPremiumToStandardModalComponent }) => RecommendPremiumToStandardModalComponent,
		),
	{ entryFsSsrLiftImportToModule: false },
);

export const AsyncRecommendPremiumToStandardModalWrapper = (): React.JSX.Element => {
	return (
		<ErrorBoundary id="recommend-premium-to-standard-modal-async" packageName={PACKAGE_NAME}>
			<ReportErrors
				teamName={TEAM_NAME}
				id="recommend-premium-to-standard-modal-async"
				packageName={PACKAGE_NAME}
			>
				<AsyncRecommendPremiumToStandardModalComponent />
			</ReportErrors>
		</ErrorBoundary>
	);
};
